// Prevent browser auto-restoration which can cause a native jump
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

// 1. Register GSAP Plugin
gsap.registerPlugin(ScrollTrigger);

// 2. Initialize Lenis
const lenis = new Lenis({
  smooth: true,
  lerp: 0.1,
});

// Save possible initial hash and prevent the native jump
const initialHash = location.hash; // e.g. "#section"
let ignoreSnapUntil = 0; // timestamp until which snap logic is ignored

if (initialHash) {
  // Prevent native jump during load
  window.scrollTo(0, 0);

  // Ignore snap logic for a short period so the initial hash scroll is not overwritten
  // Make the window sufficiently long to encompass your lenis scroll animation durations
  ignoreSnapUntil = performance.now() + 1500;
}

// 3. Animation loop for Lenis + GSAP ScrollTrigger sync
function raf(time) {
  lenis.raf(time);
  ScrollTrigger.update(); // sync GSAP
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

// If there was a hash, let Lenis jump to it immediately (no animation)
if (initialHash) {
  // Defer to next tick so Lenis is ready
  requestAnimationFrame(() => {
    // duration: 0 ensures there is no smooth animation and thus no visible flicker
    try {
      lenis.scrollTo(initialHash, { offset: 0, duration: 0 });
    } catch (e) {
      // Fallback: if lenis.scrollTo doesn't accept a hash, try element
      const el = document.querySelector(initialHash);
      if (el) {
        lenis.scrollTo(el, { offset: 0, duration: 0 });
      }
    }
    // update lastScroll (if you rely on it later)
    lastScroll = window.scrollY;
    // clear the ignore shortly after (extra safety)
    setTimeout(() => {
      ignoreSnapUntil = 0;
    }, 1600);
  });
}

//lenis snap scrool
let hasSnappedDown = false;
let hasSnappedUp = false;
let lastScroll = window.scrollY;

// Typ für easing-Funktion definieren (optional)
const customEase = (t) => 1 - Math.pow(1 - t, 3);

lenis.on('scroll', () => {
  // If we're in the initial grace period, don't run snap logic
  if (performance.now() < ignoreSnapUntil) {
    lastScroll = window.scrollY;
    return;
  }

  const currentScroll = window.scrollY;
  const scrollDelta = currentScroll - lastScroll;

  // Snap nach unten beim ersten echten Scroll
  if (!hasSnappedDown && scrollDelta > 5 && currentScroll > 10) {
    hasSnappedDown = true;

    lenis.scrollTo('#theme-page-main', {
      offset: 0,
      duration: 1.2,
      easing: customEase,
    });
  }

  // Snap zurück nach oben
  if (!hasSnappedUp && hasSnappedDown && scrollDelta < -5 && currentScroll < 200) {
    hasSnappedUp = true;

    lenis.scrollTo('.hero.tall', {
      offset: 0,
      duration: 1.2,
      easing: customEase,
    });
  }

  lastScroll = currentScroll;
});

// Intercept internal anchor clicks and use Lenis to scroll (prevents native jump on click)
document.addEventListener('click', (ev) => {
  const a = ev.target.closest && ev.target.closest('a');
  if (!a) return;

  // Only intercept same-page anchors
  if (a.hash && a.origin === location.origin) {
    const target = document.querySelector(a.hash);
    if (target) {
      ev.preventDefault();
      // Use lenis smooth scroll for clicks
      lenis.scrollTo(a.hash, { offset: 0, duration: 0.9, easing: customEase });
      // update the URL without causing a navigation
      history.pushState(null, '', a.hash);

      // Optionally: ensure snap logic won't immediately override this manual jump
      ignoreSnapUntil = performance.now() + 1000;
    }
  }
}, { passive: false });

// Handle browser Back/Forward navigation to hashes
window.addEventListener('popstate', () => {
  if (location.hash) {
    const hash = location.hash;
    const target = document.querySelector(hash);
    if (target) {
      // Smooth-ish scroll on history navigation
      lenis.scrollTo(hash, { offset: 0, duration: 0.6, easing: customEase });
      ignoreSnapUntil = performance.now() + 800;
    }
  }
});


// ---------- your existing GSAP/Lenis animations ----------

let fadePin = gsap.timeline({
  scrollTrigger: {
    trigger: '.hero.tall',
    start: 'top top',
    end: '+=120%', // oder mehr für längeren Effekt
    scrub: true,
    pin: '.tall .parallax-text',
    pinSpacing: false,
  },
});

fadePin.fromTo('.tall .parallax-text', { opacity: 1 }, { opacity: 0 });

gsap.to('.hero.tall .parallax-image2', {
  y: 600, // je höher, desto langsamer (z. B. 50–150px)
  ease: 'none',
  scrollTrigger: {
    trigger: '.hero.tall',
    start: 'top top',
    end: 'bottom top',
    scrub: true,
  },
});

gsap.to('.hero.small.header .parallax-image2', {
  y: 600, // je höher, desto langsamer (z. B. 50–150px)
  ease: 'none',
  scrollTrigger: {
    trigger: '.hero.small.header',
    start: 'top top',
    end: 'bottom top',
    scrub: true,
  },
});

gsap.utils.toArray('.hero.small').forEach((section) => {
  const image = section.querySelector('.parallax-image2');

  if (image) {
    gsap.to(image, {
      yPercent: 100,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      },
    });
  }
});


const nav = document.getElementById('theme-page-navigation');
const header = document.getElementById('theme-page-header-pane');
let isDocked = false;

function checkPosition() {
  if (!nav || !header) return;
  const navRect = nav.getBoundingClientRect();
  const headerRect = header.getBoundingClientRect();

  const navBottom = navRect.top + navRect.height;
  const headerBottom = headerRect.bottom;

  if (navBottom >= headerBottom && !isDocked) {
    isDocked = true;
    gsap.to(nav, {
      duration: 0.1,
      backgroundColor: 'rgb(4, 34, 60)',
      ease: 'none',
    });
  } else if (navBottom < headerBottom && isDocked) {
    isDocked = false;
    gsap.to(nav, {
      duration: 0.1,
      backgroundColor: 'transparent',
      ease: 'none',
    });
  }
}

window.addEventListener('scroll', checkPosition);
window.addEventListener('resize', checkPosition);
checkPosition();